import { IUserState, initialUserState } from './user.state';
import { initialRegistrationState, IRegistrationState } from './registration.state';
import { initialTempPlannedPortfoliosState, ITempPlannedPortfoliosState } from './temp-planned-portfolios.state';
import { IPlannedPortfoliosState, initialPlannedPortfoliosState } from './planned-portfolios.state';
import { initialGeneralSelectionState, IGeneralSelectionState } from './general-selection.state';
import { initialCashflowState, ICashflowState } from './cashflow.state';
import { IHoldingsState, initialHoldingsState } from './holdings.state';
import { IClientState, initialClientState } from './client.state';
import { IGlobalNotificationState, initialGlobalNotificationState } from './global-notification.state';
import { PerformanceState, initialPerformanceState } from './performance.state';
import { IPortfoliosState, initialPortfolioState } from './portfolios.state';
import { IModelPortfoliosState, initialModelPortfoliosState } from './model-portfolios.state';
import { ITransactionsState, initialTransactionsState, ITransactionStates, initialTransactionStates } from './transactions-state';
import { ISystemState, initialSystemState } from './system.state';
import { initialUtilitiesState, IUtilitiesState } from './utilities.state';
import { ITradingState, initialTradingState } from "./order.state";
import { ITransactionTypesState, initialTransactionTypesState } from './transaction-type.state';
import { IDocumentLibraryState, initialDocumentLibraryState } from './document-library.state';
import { IWithdrawalState, initialWithdrawalState } from './withdrawal.state';
import { initialReportRequestState, ReportRequestState } from './report-request.state';
import { IInvestorState, initialInvestorState } from './investor.state';

export interface IAppState {
  user: IUserState;
  cashflow: ICashflowState;
  client: IClientState;
  globalNotification: IGlobalNotificationState;
  generalSelection: IGeneralSelectionState;
  holdings: IHoldingsState;
  modelPortfolios: IModelPortfoliosState;
  plannedPortfolios: IPlannedPortfoliosState;
  tempPlannedPortfolios: ITempPlannedPortfoliosState;
  performance: PerformanceState;
  portfolios: IPortfoliosState;
  registration: IRegistrationState;
  transactions: ITransactionStates;
  transactionTypes: ITransactionTypesState;
  system: ISystemState;
  utilities: IUtilitiesState;
  tradings: ITradingState;
  documentLibrary: IDocumentLibraryState;
  withdrawals: IWithdrawalState;
  reportRequests : ReportRequestState;
  investorState : IInvestorState;
}

export const initialAppState: IAppState = {
  user: initialUserState,
  cashflow: initialCashflowState,
  client: initialClientState,
  globalNotification: initialGlobalNotificationState,
  generalSelection: initialGeneralSelectionState,
  holdings: initialHoldingsState,
  modelPortfolios: initialModelPortfoliosState,
  plannedPortfolios: initialPlannedPortfoliosState,
  tempPlannedPortfolios: initialTempPlannedPortfoliosState,
  registration: initialRegistrationState,
  performance: initialPerformanceState,
  portfolios: initialPortfolioState,
  transactions: initialTransactionStates,
  system: initialSystemState,
  utilities: initialUtilitiesState,
  transactionTypes: initialTransactionTypesState,
  tradings: initialTradingState,
  documentLibrary: initialDocumentLibraryState,
  withdrawals: initialWithdrawalState,
  reportRequests : initialReportRequestState,
  investorState : initialInvestorState
};

export function getInitialState(): IAppState {
  return initialAppState;
}
